import { render, staticRenderFns } from "./priceAndCoverage.vue?vue&type=template&id=7a712110&"
import script from "./priceAndCoverage.vue?vue&type=script&lang=js&"
export * from "./priceAndCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports